import { BookingInvalidTimeReason } from "./../enums";
import { IOpeningHours } from "../interfaces";

export const OFFICE_CLOSED_INVALID_STATES = [
  BookingInvalidTimeReason.PAST_DAY,
  BookingInvalidTimeReason.OFFICE_CLOSED,
  BookingInvalidTimeReason.OFFICE_CLOSED_ALL_DAYS,
];

export const ALL_FLOORS_ID = "all";

export const weekDays: (keyof IOpeningHours)[] = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

export const THIRTY_MINUTES_IN_MILLISECONDS = 1800000;
